"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeterministicSampler = exports.configureDeterministicSampler = void 0;
const sdk_trace_base_1 = require("@opentelemetry/sdk-trace-base");
const util_1 = require("./util");
/**
 * Builds and returns a Deterministic Sampler that uses the provided sample rate to
 * configure the inner sampler.
 * @param options The {@link HoneycombOptions}
 * @returns a {@link DeterministicSampler}
 */
const configureDeterministicSampler = (options) => {
    const sampleRate = (0, util_1.getSampleRate)(options);
    return new DeterministicSampler(sampleRate);
};
exports.configureDeterministicSampler = configureDeterministicSampler;
/**
 * A {@link Sampler} that uses a deterministic sample rate to configure the sampler.
 */
class DeterministicSampler {
    constructor(sampleRate) {
        this._sampleRate = sampleRate;
        switch (sampleRate) {
            // sample rate of 0 means send nothing
            case 0:
                this._sampler = new sdk_trace_base_1.AlwaysOffSampler();
                break;
            // sample rate of 1 is default, send everything
            case 1:
                this._sampler = new sdk_trace_base_1.AlwaysOnSampler();
                break;
            default: {
                const ratio = 1.0 / sampleRate;
                this._sampler = new sdk_trace_base_1.TraceIdRatioBasedSampler(ratio);
                break;
            }
        }
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const result = this._sampler.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return Object.assign(Object.assign({}, result), { attributes: Object.assign(Object.assign({}, result.attributes), { SampleRate: this._sampleRate }) });
    }
    toString() {
        return `DeterministicSampler(${this._sampler.toString()})`;
    }
}
exports.DeterministicSampler = DeterministicSampler;
